import './GiftCard.css'
import { IonCol, IonContent, IonText, IonGrid, IonHeader, IonImg, IonItem, IonPage, IonRow, IonSearchbar, useIonAlert, IonToolbar, IonCard, IonCardHeader, IonCardSubtitle, IonButtons, IonIcon, IonLoading, IonButton, IonTitle } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ebioroApi } from "../../services/api/ebioro/ebioro";
import { useAppDispatch } from "../../services/redux/hook";
import { TopUpProvider } from '../../types/types';
import * as Sentry from '@sentry/react';
import { closeOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { setGiftCardProducts } from '../../services/redux/slices/giftcards_products/giftcards_products';
import { setGiftCardProviders } from '../../services/redux/slices/giftcards_providers/giftcards_providers';
import { setSeletedGiftCardProvider } from '../../services/redux/slices/giftcards_provider_selected/selected_giftcard_provider';
import GitCardProductPage from './GitCardProductPage';
import { closeModal } from '../../services/redux/slices/opened_navigation_modal/opened_root_modal';
import { Provider } from 'react-redux';
import { store } from '../../services/redux/store';


const Page: React.FC = () => {

    const [presentAlert] = useIonAlert();
    const { t, i18n } = useTranslation();
    const [isComponentUnmounted, setIsComponentUnmounted] = useState(false);

    const nav = document.querySelector("ion-nav");
    const dispatch = useAppDispatch();
    const [searchValue, setSearchValue] = useState<string>('');
    const [allGiftcardProviders, setAllGiftcardProviders] = useState<TopUpProvider[]>([]);
    const [giftCardProviders, setGifCardProviders] = useState<TopUpProvider[]>([]);

    const presentErrorAlert = (error: string) => {
        presentAlert({
            header: "Error",
            message: `${error}`,
            buttons: [
                {
                    text: "Close",
                    role: "cancel",
                    handler: () => {
                        return;
                    },
                },
            ],
        });
    };

    const close = () => {

        dispatch(closeModal());

    }


    const handleChange = async (ev: Event) => {

        let query = "";
        const target = ev.target as HTMLIonSearchbarElement;

        if (target) {
            query = target.value!.toLowerCase();
            setSearchValue(target.value!);
        }

        const filteredProviders: TopUpProvider[] = [];


        allGiftcardProviders?.map((b) => {


            if (b.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {

                filteredProviders.push(b);


            }

        })

        setGifCardProviders(filteredProviders)
    }

    const goToTopUpProducts = async (provider: TopUpProvider) => {

        // first check if the provider is available
        const response = await dispatch(ebioroApi.endpoints.getToUpProviderStatus.initiate({ provider_codes: provider.provider_code })).unwrap();

        if (!response.IsProcessingTransfers) {

            presentAlert({
                header: t('giftcard.provider.page.ALERT-HEADER'),
                message: t('giftcard.provider.page.ALERT-BODY'),
                buttons: [
                    {
                        text: t('giftcard.provider.BTN-CONFIRM'),
                        role: 'confirm',
                        handler: async () => {

                        },
                    },
                ],
            })
        
            return

        }

        dispatch(setSeletedGiftCardProvider(provider));
        nav?.push(() => <GitCardProductPage />);

    }

    const handleScrollStart = async () => {

        if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
            Keyboard.hide();
        }

    }

    const getGiftCards = async () => {

        try {

    
            const response = await dispatch(ebioroApi.endpoints.getGiftCards.initiate({})).unwrap();

            if (isComponentUnmounted) return;

            let providers: TopUpProvider[] = []

            for (let i = 0; i < response.providers.length; i++) {

                if (response.providers[i].name && response.providers[i].logo_url) {
                    providers.push(response.providers[i])
                }

            }

            providers.sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()))

            dispatch(setGiftCardProducts(response.products))
            dispatch(setGiftCardProviders(providers));
            setAllGiftcardProviders(providers);
            setGifCardProviders(providers);

        } catch (error) {
            Sentry.captureException(error)
            presentErrorAlert(t('application.uncaught.ERROR'))
        }

    }

    useEffect(() => {
        getGiftCards();
        return () => {
            setIsComponentUnmounted(true);
        };
    }, [])


    return (
        <IonPage>

            <IonHeader className='ion-no-border'>
                <IonToolbar >
                    <IonButtons slot='start'>
                        <IonButton color={'primary'} onClick={() => close()}>
                            <IonIcon slot='start' icon={closeOutline}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle> {t('giftcard.provider.page.HEADER') as string}</IonTitle>
                </IonToolbar>
                <IonToolbar style={{ marginTop: "5%" }} >
                    <IonSearchbar
                        className="searchbar-input search-bar-global"
                        value={searchValue}
                        onIonInput={(ev:any) => handleChange(ev)}
                        placeholder={t('giftcard.provider.SEARCH-BAR-PLACEHOLDER') as string}
                        debounce={1000}
                    >

                    </IonSearchbar>

                </IonToolbar>
            </IonHeader>

            <IonContent scrollEvents={true}
                onIonScrollStart={handleScrollStart} >

                <IonGrid className='ion-padding'>
                    <IonRow>
                        {

                            giftCardProviders.map((item, index) => {

                                return (

                                    <IonCol size='6' key={index}>


                                        <IonCard className='giftCardProviderPage'

                                            onClick={() => { goToTopUpProducts(item) }}
                                        //disabled={!item.processing_transfers}
                                        >
                                            <IonImg src={item.logo_url} />
                                            <IonCardHeader>
                                                <IonCardSubtitle>{item?.name}</IonCardSubtitle>
                                            </IonCardHeader>

                                        </IonCard>
                                    </IonCol>

                                )
                            })
                        }


                    </IonRow>
                </IonGrid>


                {/* <IonLoading isOpen={showLoading} /> */}

            </IonContent>

        </IonPage>
    )
}

const GiftCardProviderPage: React.FC = () => (
    <Provider store={store}>
      <Page />
    </Provider>
  );
  
  export default GiftCardProviderPage;

// export default React.memo(GiftCardProviderPage)